import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { convertFullWidthNumbersToHalfWidth, getFormattedDate, isEmpty } from '../../utils/CDPUtils'
import { CDP_PUBLIC_URL, CDP_API_URL, NUMERIC_FIELDS_ARRAY } from '../../utils/Constants'
import { validateForm, errorMessages, validateFieldValue } from './FormValidationRules'

const useForm = () => {
    const [values, setValues] = useState({})
    const [errors, setErrors] = useState({})
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isValidForm, setIsValidForm] = useState(false)
    const [isValid] = useState('')
    const contractFieldsArray = ['day', 'month', 'year']
    const navigate = useNavigate()

    useEffect(() => {
        if (isSubmitting) {
            navigate(`${CDP_PUBLIC_URL}/recruit/confirm`, { state: values })
        }
    }, [isSubmitting, values, navigate])

    const apiValidate = async () => {
        try {
            const res = await fetch(`${CDP_API_URL}/validate-names`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(values)
            })

            const data = await res.json()
            const newError = {}
            data.systemMessages.forEach(item => {
            if (item.messageCode !== 'datavalidated') {
                newError.headError = errorMessages.headError
            }
            if (item.messageCode === 'SVC_10_400_2') {
                newError.nameKanji = errorMessages.nameKanji
            }
            if (item.messageCode === 'SVC_10_400_1') {
                newError.nameKana = errorMessages.nameKana
            }
            if (item.messageCode === 'SVC_10_400_3') {
                newError.age = errorMessages.age
            }
             if (item.messageCode === 'SVC_10_400_3_1') {
                newError.age = errorMessages.age1
            }
            if (item.messageCode === 'SVC_10_400_3_2') {
                newError.age = errorMessages.ageInvalid
            }
            if (item.messageCode === 'SVC_10_400_18') {
                newError.phoneNumberInvalid = errorMessages.phoneNumberInvalid
            }
            if (item.messageCode === 'SVC_10_400_19') {
                newError.onlyKana = errorMessages.onlyKana
            }
            if (item.messageCode === 'SVC_10_400_20') {
                newError.mailPattern = errorMessages.mailPattern
            }
            if (item.messageCode === 'SVC_10_400_4') {
                newError.phoneNumber = errorMessages.phoneNumber
            }
            if (item.messageCode === 'SVC_10_400_5') {
                newError.mailId = errorMessages.mailId
            }
            if (item.messageCode === 'SVC_10_400_6') {
                newError.confirmMailId = errorMessages.confirmMailId
            }
            if (item.messageCode === 'SVC_10_400_7') {
                newError.finalEduBgTypes = errorMessages.finalEduBgTypes
            }
            if (item.messageCode === 'SVC_10_400_8') {
                newError.workExperienceTypes = errorMessages.workExperienceTypes
            }
            if (item.messageCode === 'SVC_10_400_9') {
                newError.changeOccupationTypes = errorMessages.changeOccupationTypes
            }
            if (item.messageCode === 'SVC_10_400_10') {
                newError.nowOccupationTypes = errorMessages.nowOccupationTypes
            }
            if (item.messageCode === 'SVC_10_400_12') {
                newError.whereCDPMemoTypes1 = errorMessages.whereCDPMemoTypes1
            }
            if (item.messageCode === 'SVC_10_400_13') {
                newError.whereCDPMemoTypes2 = errorMessages.whereCDPMemoTypes2
            }
            if (item.messageCode === 'SVC_10_400_14') {
                newError.checkMailId = errorMessages.checkMailId
            }
            if (item.messageCode === 'SVC_10_400_16') {
                newError.checkMailId = errorMessages.nameLenght
            }
            if (item.messageCode === 'SVC_10_400_17') {
                newError.checkMailId = errorMessages.nameLenght
            }
            })

            setErrors(newError)
            if (Object.keys(newError).length === 0) {
                setIsSubmitting(true)
            } else {
                document.getElementById('entryCDP').scrollIntoView()
            }
        } catch (error) {
            console.error('Error submitting the form:', error)
        }
    }

    const handleSubmit = (event) => {
        if (event) event.preventDefault()
        apiValidate()
    }

    const handleBlur = (event) => {
        const fieldName = event.target.name
        if (NUMERIC_FIELDS_ARRAY.includes(fieldName)) {
            const convertedValue = convertFullWidthNumbersToHalfWidth(event.target.value, event.target.name)
            setValues(values => ({ ...values, [event.target.name]: convertedValue }))
        }
        const errorMessage = validateFieldValue(fieldName, values[fieldName], values, errors)
        if (!isEmpty(errorMessage)) {
            setErrors(errors => ({ ...errors, [fieldName]: errorMessage }))
        }
        setIsValidForm(validateForm(values))
    }

    const handleChange = (event) => {
        if (event.target.type === 'checkbox') {
                if (event.target.checked) {
                    setValues({ ...values, [event.target.id]: event.target.value })
                } else {
                    const { [event.target.id]: removedProp, ...newValues } = values
                    setValues(newValues)
                }
        } else if (event.target.type !== 'checkbox') {
            setValues({ ...values, [event.target.name]: event.target.value })
            handleDateChange(event.target.name, event.target.value, values)
            setDate(event.target.name, event.target.value)
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ''
        }))
    }

    function handleDateChange (fieldName, fieldValue, values) {
        if ((fieldName === 'year' || fieldName === 'dobyear') && !isEmpty(fieldValue)) {
            const now = new Date()
            const currentYear = now.getFullYear()
            const currentMonth = now.getMonth()
            const monthField = (fieldName === 'year') ? 'month' : 'dobmonth'
            const monthValue = Number(values[monthField]) - 1
            const dayField = (fieldName === 'year') ? 'day' : 'dobday'
            if (currentYear === Number(fieldValue) && (monthValue) > currentMonth) {
                setValues(values => ({ ...values, [monthField]: '' }))
            }
            setValues(values => ({ ...values, [dayField]: '' }))
        } else if ((fieldName === 'month' || fieldName === 'dobmonth') && !isEmpty(fieldValue)) {
            const dayField = (fieldName === 'month') ? 'day' : 'dobday'
            setValues(values => ({ ...values, [dayField]: '' }))
        }
    }

    function setDate (field, value) {
        if (values.noContractDate !== '0' && field === 'day') {
            setValues(values => ({
                ...values,
                contractApplDate: getFormattedDate(value, values.month, values.year)
            }))
        } else if (field === 'dobday') {
            setValues(values => ({
                ...values,
                dateOfBirth: getFormattedDate(value, values.dobmonth, values.dobyear)
            }))
        }
    }

    const handleOnLoad = (values, from) => {
        setValues(values)
        let valid = true
        if (from === 'SuccessPage') {
            valid = false
        }
        if (values.noContractDate === '0') {
            contractFieldsArray.forEach(e => {
                document.getElementById(e).disabled = true
            })
        }
        if (document.getElementById('noContractDate')) {
            document.getElementById('noContractDate').focus()
        }
        setIsValidForm(valid)
        setIsSubmitting(false)
    }

    return {
        handleChange,
        handleBlur,
        handleSubmit,
        handleOnLoad,
        values,
        errors,
        isValidForm,
        isValid
    }
}

export default useForm
